import React from 'react';
import { WorkflowTimeline } from '../../WorkflowTimeline';
import { DocumentHistoryModalShell } from './DocumentHistoryModalShell';

interface DocumentWorkflowHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentId: string;
  documentTitle: string;
}

export const DocumentWorkflowHistoryModal: React.FC<DocumentWorkflowHistoryModalProps> = ({
  isOpen,
  onClose,
  documentId,
  documentTitle,
}) => {
  return (
    <DocumentHistoryModalShell
      isOpen={isOpen}
      onClose={onClose}
      documentTitle={documentTitle}
      title="Histórico do workflow"
    >
      <WorkflowTimeline documentId={documentId} variant="embedded" />
    </DocumentHistoryModalShell>
  );
};
